import { Trans, useTranslation } from 'react-i18next'
import { INTERFACE_CARDS } from './constants'

export function InterfaceContent() {
  const { t } = useTranslation()

  return (
    <div className="bg-card px-6 py-4">
      <p className="text-foreground mb-2 text-base leading-relaxed font-normal">
        <Trans
          i18nKey="discover.sections.interfaceIntro1"
          components={{ 1: <span className="font-semibold" /> }}
        />
      </p>
      <p className="text-foreground mb-0 text-base leading-relaxed font-normal">
        <Trans
          i18nKey="discover.sections.interfaceIntro2"
          components={{ 1: <span className="font-semibold" /> }}
        />
      </p>
      <div className="mt-[14px] grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {INTERFACE_CARDS.map(card => (
          <div
            key={card.titleKey}
            className={`${card.cardBg} flex min-h-[200px] flex-col rounded-2xl p-4`}
          >
            <div
              className={`${card.iconBg} mb-3 flex h-[30px] w-[30px] items-center justify-center rounded-full`}
            >
              <img
                src={card.icon}
                alt=""
                width={16}
                height={16}
                className="h-4 w-4 object-contain"
              />
            </div>
            <h3 className="text-foreground mb-2 text-base font-bold">{t(card.titleKey)}</h3>
            <p className="text-foreground text-sm leading-relaxed font-normal">
              {t(card.descriptionKey)}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
